import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Dropdown } from 'primereact/dropdown';
import APIConstant from "../../utils/pathConstants";
import api from "../../utils/apiClient";
import CommonConfig from '../../utils/constant';
import { useCatchResponse } from '../../utils/useCatchResponse';
import moment from 'moment';

const AcademicYearSelector = (props) => {
    const { catchResponse } = useCatchResponse();
    const navigate = useNavigate();
    const [userId, setUserId] = useState('');
    const [selectedYear, setSelectedYear] = useState('');
    const [financialYears, setFinancialYears] = useState([]);

    useEffect(() => {
        const loginData = CommonConfig.loginData();
        setUserId(loginData?._id);
        if (loginData?.UserRole === 'Parent') {
            getFinancialYearClassList(loginData?.CreatedBy);
        } else {
            getFinancialYearData(loginData);
        }
    }, []);

    const getFinancialYearData = async (loginData) => {
        const years = await CommonConfig.getFinancialYears(CommonConfig.isOrgOwner(loginData?.UserRole) ? loginData?._id : loginData?.CreatedBy);
        setFinancialYears(years);
        const currentYear = CommonConfig.getCurrentFinancialYear(years);
        const selectedAcYear = CommonConfig.getCookie('selectedAcademicYear');
        setSelectedYear(loginData?.SelectedAcademicYear || selectedAcYear || currentYear?.value);
    }

    const getFinancialYearClassList = async (id) => {
        try {
            let data = {
                UserID: id,
            }
            await api.post(APIConstant.path.getAcademicCalanderClassList, data).then(async response => {
                let res = response;
                if (res.success) {
                    if (res?.data) {
                        const filterData = res?.data;
                        setFinancialYears(filterData);
                        const selectedAcYear = CommonConfig.getCookie('selectedAcademicYear');
                        setSelectedYear(selectedAcYear ?? '');
                    }
                } else {
                    console.log("Error in else get Financial Year: ", res);
                }
            }).catch(err => {
                console.log(err);
                catchResponse(err);
            });
        } catch (error) {
            console.log("Error get Financial Year: ", error);
            catchResponse(error);
        }
    }

    const handleYearChange = useCallback(async (e) => {
        const loginData = CommonConfig.loginData();
        
        if (!loginData) {
            console.error('Login data not found');
            return;
        }
        
        setSelectedYear(e?.value);
        CommonConfig.setCookie('selectedAcademicYear', e?.value);
        let data = {
            id: loginData?._id,
            SelectedAcademicYear: e?.value
        };
        await api.post(APIConstant.path.AddUpdateUser, data).then(async response => {
            let res = response;
            if (res.success) {
                if (loginData) {
                    loginData.SelectedAcademicYear = e?.value;
                    localStorage.setItem('ERPLoginData', JSON.stringify(loginData));
                }
                navigate(0);
            }
        })
            .catch((err) => {
                console.error(err);
            });
    }, [])

    // Compact value display for the sidebar card: "YYYY-YY" instead of the verbose label
    const compactValueTemplate = (option) => {
        if (!option) return <span>Select Year</span>;
        const start = option?.StartDate ? moment(option.StartDate).format('YYYY') : '';
        const end = option?.EndDate ? moment(option.EndDate).format('YY') : '';
        return <span>{start && end ? `${start}-${end}` : option?.label}</span>;
    };

    return (
        <div className="e-select-year">
            <Dropdown
                className={props?.compact ? 'p-w-100' : 'p-w-100 p-mt-1'}
                name='selectedYear'
                inputId='selectedYear'
                value={selectedYear}
                options={financialYears}
                onChange={handleYearChange}
                placeholder={props?.compact ? 'Select Year' : 'Select Academic Year'}
                optionLabel="label"
                optionValue="_id"
                valueTemplate={props?.compact ? compactValueTemplate : undefined}
                filter
            />
        </div>
    );
};

export default AcademicYearSelector;